import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { ApiFlow } from './common';

export function useInitFlow<FLOW extends ApiFlow>(
  flowType: string,
  flowInitter: () => () => Promise<AxiosResponse<FLOW>>
) {
  const initFlowQuery = useQuery({
    queryKey: ['kratos', 'flow', 'init', flowType],
    queryFn: flowInitter()
  });
  const flowId = initFlowQuery.data?.data.id ?? '';

  let initFlowStatusElement = <></>;
  if (initFlowQuery.isLoading) {
    initFlowStatusElement = <div>Initializing flow..</div>;
  }
  else if (initFlowQuery.isError || !initFlowQuery.isSuccess) {
    initFlowStatusElement = <div>Failed to initialize flow.</div>;
  }

  return {
    flowId, initFlowQuery, initFlowStatusElement
  };
}
